import { useCallback, useState } from 'react';
import { useTranslation } from '../../../utils/useTranslation';
import { confirmAlert } from '../../feedback/Alert';
import { SmartDrawer } from '../../feedback/SmartDrawer';
import { Button } from '../../input/Button';
import { FormControlGroup } from '../../input/FormControlGroup';
import { DataTestId } from '../../layout/DataTestIdWrapper';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import {
    BUSINESS_ACCOUNT_TEXT,
    SERVICE_ACCOUNT_TEXT,
} from '../BusinessRegistrationAccount/constants';
import { BusinessRegistrationAccountControl } from '../BusinessRegistrationAccountControl/BusinessRegistrationAccountControl';
import { BusinessType } from '../types';
import { BusinessTypeAccountDrawerProps } from './types';

export const BusinessTypeAccountDrawer = ({
    type: typeBase,
    onChange: onChangeBase,
    onClose,
}: BusinessTypeAccountDrawerProps) => {
    const t = useTranslation();
    const [type, setType] = useState<BusinessType | undefined>(typeBase);

    const onChange = (value: BusinessType) => {
        setType(value);
    };

    const onSubmit = useCallback(() => {
        onClose();

        if (typeBase === type) {
            return;
        }

        const warningText =
            typeBase === BusinessType.BUSINESS
                ? t(
                      'Вы уверены, что хотите изменить тип аккаунта? Кнопка каталога и прикрепленные товары в постах пропадут.',
                  )
                : t('Вы уверены, что хотите изменить тип аккаунта?');

        confirmAlert(t('Изменение типа аккаунта'), warningText, undefined, t('Изменить'))
            .then(() => {
                if (!type || !onChangeBase) {
                    return;
                }

                onChangeBase(type);
            })
            .catch(() => {});
    }, [type, typeBase, onChangeBase, onClose, t]);

    return (
        <SmartDrawer
            maxWidth="512px"
            onClose={onClose}
            dataTestId={DataTestId.BUSINESS_TYPE_ACCOUNT_DRAWER}
            titleContent={
                <Typography variant="title3" weight="bold" mr={2}>
                    {t('Тип аккаунта')}
                </Typography>
            }
            mainContent={() => (
                <Flex width="100%">
                    <Typography>
                        {t('При смене типа аккаунта некоторые данные могут быть утеряны')}
                    </Typography>
                    <FormControlGroup mt={2} width="100%" spacing={1} onChange={onChange}>
                        <BusinessRegistrationAccountControl
                            {...BUSINESS_ACCOUNT_TEXT}
                            value={BusinessType.BUSINESS}
                            checked={type === BusinessType.BUSINESS}
                            onChange={onChange}
                        />
                        <BusinessRegistrationAccountControl
                            {...SERVICE_ACCOUNT_TEXT}
                            value={BusinessType.SERVICE}
                            checked={type === BusinessType.SERVICE}
                            onChange={onChange}
                        />
                    </FormControlGroup>
                    <Button size="l" color="primary" width="100%" onClick={onSubmit} mt={2}>
                        {t('Изменить')}
                    </Button>
                </Flex>
            )}
        />
    );
};
